export const UPDATE_VALUE = "UPDATE_VALUE";
export const CLEAR = "CLEAR";
export const ENTER = "ENTER";

export const operatorsLst = ["+", "-", "*", "/"];
export const padChar = [
  "/",
  "*",
  "7",
  "8",
  "9",
  "-",
  "4",
  "5",
  "6",
  "+",
  "1",
  "2",
  "3",
];
